import React from "react";
import { string } from "prop-types";

import BQLogo from "../../atoms/icons/bq-logo";
import FitColorLogo from "../../atoms/icons/fit-color-logo";
import QuintHindiLogo from "../../atoms/icons/quint-hindi-logo";
import TheQuintLogo from "../../atoms/icons/the-quint-logo";
import LinkView from "../../atoms/link-view";

import "./mobile-logos.m.css";

const PopupMobileLogoView = ({ publisherName }) => {
  const quintLogos = () => (
    <React.Fragment>
      <LinkView link="https://hindi.thequint.com/" className="header-hq-logo hindi-color-logo">
        <QuintHindiLogo width={84} height={30} />
      </LinkView>
      <LinkView link="https://fit.thequint.com/" className="header-fit-logo fit-color-logo">
        <FitColorLogo width={52} height={30} />
      </LinkView>
    </React.Fragment>
  );

  const hindiLogos = () => (
    <React.Fragment>
      <LinkView link="https://www.thequint.com/" className="header-tq-logo engish-quint-logo">
        <TheQuintLogo width={54} height={36} />
      </LinkView>
      <LinkView link="https://fit.thequint.com/" className="header-fit-logo fit-color-logo">
        <FitColorLogo width={52} height={30} />
      </LinkView>
    </React.Fragment>
  );

  const fitLogos = () => (
    <React.Fragment>
      <LinkView link="https://www.thequint.com/" className="header-tq-logo engish-quint-logo">
        <TheQuintLogo width={54} height={36} />
      </LinkView>
      <LinkView link="https://hindi.thequint.com/" className="header-hq-logo hindi-color-logo">
        <QuintHindiLogo width={84} height={30} />
      </LinkView>
    </React.Fragment>
  );

  const getLogos = () => {
    switch (publisherName) {
      case "quint":
        return quintLogos();
      case "quint-hindi":
        return hindiLogos();
      case "fit":
        return fitLogos();
      default:
        return quintLogos();
    }
  };

  return (
    <div styleName="logo-wrapper">
      {getLogos()}
      <LinkView className="bq-mobile-logo" link="https://www.bloombergquint.com/">
        <BQLogo width={146} height={30} />
      </LinkView>
    </div>
  );
};

PopupMobileLogoView.propTypes = {
  publisherName: string,
};

export default PopupMobileLogoView;
